require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-pearl-agarwal.json") })
        }
      }, "path---insights-pearl-agarwal");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-pearl-agarwal!./.cache/json/insights-pearl-agarwal.json
// module id = 1135
// module chunks = 231608221292675